import React from 'react';
import TabBar from '../TabBar/TabBar';
import {
  STUDENT_NOTES_MODAL_TABS,
  type StudentNotesModalTabKey,
} from './studentNotesModal.constants';
import styles from './StudentNotesModalTabs.module.css';

interface StudentNotesModalTabsProps {
  activeTab: StudentNotesModalTabKey;
  showSummary?: boolean;
  onTabChange: (tab: StudentNotesModalTabKey) => void;
  children: React.ReactNode;
}

const StudentNotesModalTabs: React.FC<StudentNotesModalTabsProps> = ({
  activeTab,
  showSummary = true,
  onTabChange,
  children,
}) => (
  <div className={styles.tabs}>
    {showSummary && (
      <TabBar
        tabs={STUDENT_NOTES_MODAL_TABS}
        activeKey={activeTab}
        onTabChange={(key) => onTabChange(key as StudentNotesModalTabKey)}
      />
    )}
    <div className={styles.panel} role="tabpanel">
      {children}
    </div>
  </div>
);

export default StudentNotesModalTabs;
